import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import debounce from 'lodash.debounce';

const OnWindowResize = ({ children }) => {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  const onResize = debounce(() => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);
  }, 100);

  useEffect(() => {
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
      onResize.cancel();
    };
  }, []);

  return children({ width, height });
};

OnWindowResize.propTypes = {
  children: PropTypes.func.isRequired,
};

export default OnWindowResize;
